export const quotesEn =[
    {
        'text': 'What the human mind can comprehend and believe, it can achieve',
        'author': 'Napoleon Hill'
      },
      {
        'text': 'Strive not for success, but for the values ​​it gives​',
        'author': 'Albert Einstein'
      },
      {
        'text': 'I owe my success to never making excuses or accepting excuses from others.',
        'author': 'Florence Nightingale'
      },
      {
        'text': 'I\'ve missed over 9,000 shots in my career, lost nearly 300 games.',
        'author': 'Michael Jordan'
      },
      {
        'text': 'The hardest thing is to start acting, everything else depends only on perseverance',
        'author': 'Amelia Earhart'
      },
      {
        'text': 'We must love life more than the meaning of life',
        'author': 'Fedor Dostoevsky'
      },
      {
        'text': 'Life is what happens to you while you\'re making plans',
        'author': 'John Lennon'
      },
      {
        'text': 'Logic can take you from point A to point B, and imagination can take you anywhere',
        'author': 'Albert Einstein'
      },
      {
        'text': 'In 20 years, you will be more disappointed with the things you didn\'t do than with the things you did.',
        'author': 'Mark Twain'
      },
      {
        'text': 'It is always worth starting with something that sows doubt',
        'author': 'Boris Strugatsky'
      },
      {
        'text': 'Real responsibility is only personal.',
        'author': 'Fazil Iskander'
      },
      {
        'text': 'A meaningless life is not worth living',
        'author': 'Socrates'
      },
      {
        'text': '80% success is showing up in the right place at the right time',
        'author': 'Woody Allen'
      },
      {
        'text': 'Your time is limited, don\'t waste it living someone else\'s life',
        'author': 'Steve Jobs'
      },
      {
        'text': 'Winning is not everything, everything is a constant desire to win',
        'author': 'Vince Lombardi'
      },
      {
        'text': 'Science is organized knowledge, wisdom is organized life',
        'author': 'Immanuel Kant'
      },
      {
        'text': 'There is no word \'impossible\' in my dictionary',
        'author': 'Napoleon Bonaparte'
      },
      {
        'text': 'You will never cross the ocean unless you have the courage to lose sight of the shore.',
        'author': 'Christopher Columbus'
      },
      {
        'text': 'Freedom is worth nothing unless it includes the freedom to make mistakes.',
        'author': 'Mahatma Gandhi'
      },
      {
        'text': 'Either you control your day or the day controls you.',
        'author': 'Jim Rohn'
      },
      {
        'text': 'If you think you are capable of something, you are right; If you think that you will not succeed, you are also right',
        'author': 'Henry Ford'
      },
      {
        'text': 'The two most important days in your life: the day you were born and the day you realized why',
        'author': 'Mark Twain'
      },
      {
        'text': 'Start doing everything you can do - and even what you can even dream of',
        'author': 'Johann Wolfgang Goethe'
      },
      {
        'text': 'The best revenge is a huge success',
        'author': 'Frank Sinatra'
      },
      {
        'text': 'It\'s often said that motivation doesn\'t last long.',
        'author': 'Zig Ziglar'
      },
      {
        'text': 'Weak people spend their whole lives trying to be no worse than others.',
        'author': 'Boris Akunin'
      },
      {
        'text': 'It\'s all about thoughts',
        'author': 'Lev Tolstoy'
      },
      {
        'text': 'There is only one way to avoid criticism: do nothing, say nothing, and be nothing.',
        'author': 'Aristotle'
      },
      {
        'text': 'The person you are meant to be is only the person you decide to become.',
        'author': 'Ralph Waldo Emerson'
      },
      {
        'text': 'Walk confidently towards your dream',
        'author': 'Henry David Thoreau'
      },
      {
        'text': 'I hope that at the end of my days, when I stand before God, I will not have a shred of talent left so that I can tell him: “I used everything that you gave me”',
        'author': 'Erma Bombek, writer, journalist'
      },
      {
        'text': 'Indian proverbIt is better to be sure of a good result than to hope for a great one.',
        'author': 'Warren Buffett'
      },
      {
        'text': 'Some things may grab your attention, but focus on the things that grab your heart.',
        'author': 'Indian proverb'
      },
      {
        'text': 'You just have to believe that you can - and you are already halfway to the goal.',
        'author': 'ТTheodore Roosevelt'
      },
      {
        'text': 'Don\'t blame a child for being afraid of the dark',
        'author': 'Plato'
      },
      {
        'text': 'Learn to say \'I don\'t know\' and that will be progress',
        'author': 'Moses Maimonides'
      },
      {
        'text': 'Start from where you are now',
        'author': 'Arthur Ash'
      },
      {
        'text': 'When I was 5 years old, my mother always said that the main thing in life is happiness.',
        'author': 'John Lennon'
      },
      {
        'text': 'Fall down seven times and get up eight times',
        'author': 'Japanese proverb'
      },
      {
        'text': 'When one door to happiness closes, another one opens.',
        'author': 'Helen Keller'
      },
      {
        'text': 'Everything has its beauty, but not everyone can see it',
        'author': 'Confucius'
      },
      {
        'text': 'It\'s wonderful that you don\'t have to wait a minute to start making the world a better place.',
        'author': 'Anne Frank'
      },
      {
        'text': 'When I let go of who I am, I become who I can be',
        'author': 'Lao Tzu'
      },
      {
        'text': 'Happiness is not a finished product',
        'author': 'Dalai Lama'
      },
      {
        'text': 'If you\'re offered a seat on a launch vehicle, don\'t ask what seat it is! Just take it',
        'author': 'Sheryl Sandberg'
      },
      {
        'text': 'First define your ideal: set a goal',
        'author': 'Aristotle'
      },
      {
        'text': 'If there is no wind, take the oars',
        'author': 'latin proverb'
      },
      {
        'text': 'Always keep in mind that your own decision to succeed is more important than anything else.',
        'author': 'Abraham Lincoln'
      },
      {
        'text': 'Success is the ability to go from defeat to defeat without losing optimism.',
        'author': 'Winston Churchill'
      },
      {
        'text': 'They ask, \'How can you get everything done in fifteen minutes?\' I answer: \'It\'s just',
        'author': 'Richard Branson'
      },
      {
        'text': 'Everyone wants to change humanity, but no one thinks about how to change themselves',
        'author': 'Lev Tolstoy'
      },
      {
        'text': 'It is important to believe that talent is given to us for a reason - and that at any cost it must be used for something.',
        'author': 'Marie Curie'
      },
      {
        'text': 'If an inner voice tells you that you cannot draw - draw as much as possible, then this voice will subside',
        'author': 'Vincent Van Gogh'
      },
      {
        'text': 'Definiteness of purpose is the starting point of all achievement',
        'author': 'William Clement Stone'
      },
      {
        'text': 'We become what we think',
        'author': 'Earl Nightingale'
      },
      {
        'text': 'I am not a victim of circumstances, I am the result of my decisions',
        'author': 'Stephen Covey'
      },
      {
        'text': 'The best time to plant a tree was 20 years ago',
        'author': 'Chinese proverb'
      },
      {
        'text': 'All children are artists',
        'author': 'Pablo Picasso'
      },
      {
        'text': 'I was struck by the importance of taking action',
        'author': 'Leonardo da Vinci'
      },
      {
        'text': 'What is money? A person is successful if he wakes up in the morning, returns to bed in the evening, and does what he likes during the break.',
        'author': 'Bob Dylan'
      },
      {
        'text': 'I didn\'t fail the test',
        'author': 'Benjamin Franklin'
      },
      {
        'text': 'Defeat is not defeat unless you recognize it as such in your mind.',
        'author': 'Bruce Lee'
      },
      {
        'text': 'Failure is just an opportunity to start again, but more wisely.',
        'author': 'Henry Ford'
      },
      {
        'text': 'I\'m sure you can\'t let yourself be stopped by the wretched word \'no\'',
        'author': 'Richard Branson'
      },
      {
        'text': 'Only those who never try new things never make mistakes.',
        'author': 'Albert Einstein'
      },
      {
        'text': 'You become what you believe',
        'author': 'Oprah Winfrey'
      },
      {
        'text': 'Happiness is not in always doing what you want, but in always wanting what you do',
        'author': 'Lev Tolstoy'
      },
      {
        'text': 'I\'d rather die of passion than boredom',
        'author': 'Vincent van Gogh'
      },
      {
        'text': 'You learn the fastest in three cases - before the age of 7, at trainings, and when life has driven you into a corner',
        'author': 'Stephen Covey'
      },
      {
        'text': 'People will forget what you said, forget what you did, but they will never forget how you made them feel.',
        'author': 'Maya Angelou'
      },
      {
        'text': 'Our consciousness is everything',
        'author': 'Buddha'
      },
      {
        'text': 'If you want to build a ship, you don\'t have to call people, plan, divide work, get tools',
        'author': 'Antoine de Saint-Exupery'
      },
      {
        'text': 'Never think that you already know everything',
        'author': 'Ivan Pavlov'
      },
      {
        'text': 'It doesn\'t matter how slowly you walk, but how long you walk without stopping',
        'author': 'Confucius'
      },
      {
        'text': 'If you think about what you have in life, you can always have more.',
        'author': 'Oprah Winfrey'
      },
      {
        'text': 'Turn your big thoughts into big actions as quickly as possible',
        'author': 'Donald Trump'
      },
      {
        'text': 'To lead people, follow them',
        'author': 'Lao Tzu'
      },
      {
        'text': 'Remember that not achieving success is sometimes also a great success.',
        'author': 'Dalai Lama'
      },
      {
        'text': 'Always choose the most difficult path - on it you will not meet competitors',
        'author': 'Charles de Gaulle'
      },
      {
        'text': 'One completed productive task is worth fifty half-finished tasks.',
        'author': 'Malcolm Forbes'
      },
      {
        'text': 'Our lives begin to come to an end when we stop talking about the really important things.',
        'author': 'Martin Luther King Jr'
      },
      {
        'text': 'Trouble does not come alone, but luck too',
        'author': 'Romain Rolland'
      },
      {
        'text': 'Every thought is like dough, if you knead it well, you will make everything out of it.',
        'author': 'Ivan Turgenev'
      },
      {
        'text': 'Do the best you can where you are with everything you have',
        'author': 'Theodore Roosevelt'
      },
      {
        'text': 'Remember, no one can make you feel inferior without your consent.',
        'author': 'Eleanor Roosevelt'
      },
      {
        'text': 'The world is divided into two classes - some believe in the incredible, others do the impossible.',
        'author': 'Oscar Wilde'
      },
      {
        'text': 'The only happiness in life is the constant striving forward',
        'author': 'Emile Zola'
      },
      {
        'text': 'Survival is not the strongest, but the most receptive to change',
        'author': 'Charles Darwin'
      },
      {
        'text': 'You can say that you have bad genetics, bad metabolism, or you can just get your ass off the couch and start working on yourself, set a goal and believe in yourself.',
        'author': 'Arnold Schwarzenegger'
      },
      {
        'text': 'Never falling down is not the greatest merit in life',
        'author': 'Nelson Mandela'
      },
      {
        'text': 'The question is not who will allow me, but who can forbid me.',
        'author': 'Ayn Rand'
      },
      {
        'text': 'When it seems that the whole world is against you, remember that the plane does not take off with the wind, but against it.',
        'author': 'Henry Ford'
      },
      {
        'text': 'Life is measured not by how many years it has, but by how many years of real life there are.',
        'author': 'Abraham Lincoln'
      },
      {
        'text': 'Benefiting the world is the only way to be happy',
        'author': 'Hans Christian Andersen'
      },
      {
        'text': 'Either write something worthwhile or do something worth writing about',
        'author': 'Benjamin Franklin'
      },
      {
        'text': 'The only way to do something very well is to love what you do',
        'author': 'Steve Jobs'
      },
      {
        'text': 'A wise man demands everything only from himself, but an insignificant person demands everything from others.',
        'author': 'Lev Tolstoy'
      },
      {
        'text': 'Great are those who see that thoughts rule the world',
        'author': 'Ralph Emerson'
      },
      {
        'text': 'Before climbing the ladder of success, make sure it is leaning against the wall of the building you need',
        'author': 'Stephen Covey'
      },
      {
        'text': 'At the root of every successful venture is a bold decision once made.',
        'author': 'Peter Drucker'
      }
  ]